export default {
  en: {
    termsOfPayment: 'Terms of payment',
    keyword: 'Keyword',
    all: 'All Status',
    newTermsOfPayment: 'New Terms of payment',
    title: 'Title',
    detail: 'Description',
    status: 'Status',
    confirmRemoveTermsOfPaymentTitle: 'Confirm',
    confirmRemoveTermsOfPaymentMessage: 'Confirm to delete {name} terms of payment?',
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel',
    removeMarketSuccess: 'Remove terms of payment {name} success'
  },
  th: {
    termsOfPayment: 'เงื่อนไขการชำระเงิน',
    keyword: 'คำที่ต้องการค้นหา',
    all: 'สถานะทั้งหมด',
    newTermsOfPayment: 'สร้างเงื่อนไขการชำระเงิน',
    title: 'หัวข้อ',
    detail: 'รายละเอียด',
    status: 'สถานะ',
    confirmRemoveTermsOfPaymentTitle: 'ยืนยัน',
    confirmRemoveTermsOfPaymentMessage: 'ต้องการลบเงื่อนไขการชำระเงิน {name}?',
    confirmButtonText: 'ยืนยัน',
    cancelButtonText: 'ยกเลิก',
    removeMarketSuccess: 'ลบเงื่อนไขการชำระเงิน {name} สำเร็จ'
  }
}
